
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-privacidad",
      function () {
        return require("private-next-pages/politica-privacidad/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-privacidad"])
      });
    }
  